<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        Contact Group
      </span>
      <a-button size="large" class="a-header--button slide-down-enter-active" type="primary" @click="onAdd">
        <img class="mr-2 icon-size" src="@assets/icon/plus.svg" />
        Add New
      </a-button>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <template v-if="!isLoading">
        <div class="a-filter">
          <a-row class="full-w" type="flex" justify="start" :gutter="16">
            <a-col :span="5">
              <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
                <a-button size="large">
                  <a-icon type="search" />
                </a-button>
                <a-input class="custom-prefix" placeholder="Search" @change="onSearch"></a-input>
              </div>
            </a-col>
          </a-row>
        </div>
      </template>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable :pagination="pagin" :columns="ContactGroupListColumn" :dataSource="filterData" :tableSize="tableSize">
            <div slot="contacts" slot-scope="{ record }">
              <span v-for="(item, index) in record.contacts" :key="item.id" class="contact">
                {{ item.name }}
                <template v-if="index < record.contacts.length - 1">
                  ,
                </template>
              </span>
            </div>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item @click="onEdit(record)"> <a-icon type="edit"></a-icon>Edit </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" />
                      Delete
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { ContactGroupListColumn } from '../columnsTable/ContactGroupListColumn';
  import ContactGroupService from '../services/contact-group.service';

  export default {
    name: 'ContactList',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        ContactGroupListColumn,
        data: [],
        filterData: [],
        filterParams: {
          search: '',
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0,
        },
        PAGE_OPTIONS,
        tableScrollHeight: 500,
        isLoading: true,
        tableSize: {
          height: '',
          width: '',
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter(item => item.description.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length,
        };
      },
      onAdd() {
        this.$router.push('/contact-group/add');
      },
      onDelete(record) {
        ContactGroupService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Contact group');
          this.getList();
        });
      },
      onEdit(record) {
        this.$router.push({
          path: '/contact-group/' + record.id,
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList() {
        try {
          const data = await ContactGroupService.getList();
          this.data = [...(data || [])].map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          this.filter();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          }
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style></style>
